const ANALYTICS_EVENT_PROPERTIES = {
    EVENT: 'event',
    MARKET: 'market',
    EVENT_PROPERTIES: 'event_properties',
    INTERACTION_TYPE: 'interaction_type',
    ACTION_VALUE: 'action_value',
    AUTODELIVERY_STATUS: 'autodelivery_status',
    BUTTON_TYPE: 'button_type',
    CAMPAIGN_NAME: 'campaign_name',
    IQOS_PRODUCT_DEVICE_ID: 'iqos_product_device_id',
    IQOS_PRODUCT_MODEL_TYPE: 'iqos_product_model_type',
    LEGAL: 'legal',
    MESSAGE: 'message',
    PUSH_SOURCE: 'push_source',
    QUESTIONNAIRE_PAGE: 'Questionnaire_page',
    QUESTIONNAIRE_PAGE_LOWERCASE: 'questionnaire_page',
    SOURCE: 'source',
    SUCCESS: 'success',
    TRACKING_VALUE: 'tracking_value',
    ORDER_SUMMARY: 'order_summary',
    TYPE: 'type',
    DEVICE_TYPE: 'device_type',
    USER_AGENT: 'user_agent',
    PAGE_ID: 'page_id',
    USER_ID: 'user_id',
    APP_VERSION: 'app_version',
    GLOBAL_SETTING_VALUE: 'global_setting_value',
    TRIGGER: 'trigger',
};

export default ANALYTICS_EVENT_PROPERTIES;
